import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from 'src/modules/directives/module';
import { AllAdminUsersDashboard } from './components/dashboard/component';

@NgModule({
  imports: [CommonModule, MaterialModule, DirectivesModule, RouterModule],
  declarations: [AllAdminUsersDashboard],
  exports: [AllAdminUsersDashboard],
})
export class AllAdminUsersAdminModule {}
